import script from "./TeacherAttendence.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherAttendence.vue?vue&type=script&setup=true&lang=js"

import "./TeacherAttendence.vue?vue&type=style&index=0&id=66f0ff1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f0ff1a"]])

export default __exports__